import React,{useRef, useState, useEffect} from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button, Badge, InputGroup, Alert, Dropdown } from "react-bootstrap";
import {setUrlParam, timeAgo} from "../utils/functions";
import Select from "react-select";
import Footer from "../layouts/Footer";
import Sidebar from "../layouts/Sidebar";
import Header from "../layouts/Header";
import parse from 'html-react-parser';
import {projectPhaseColors, projectStatusColors} from "../data/ProjectStatusColor";
import energyTypes from "../data/energyTypes";
import vindrApi from "../utils/vindrapi";
import authApi from "../utils/authApi";
import Loader from "../components/Loader";
import Filter from "../components/Filter";
import UserMenu		from "../components/UserMenu";
import {formatDate} from  "../utils/functions";
import DialogScreeningMap from "../layouts/DialogScreeningMap";
import InfoLayers from "../components/InfoLayers";
import DialogUploadLayer from "../layouts/DialogUploadLayer";
import {drawUtils} from "../utils/drawUtils";
import drawTheme from "../utils/drawUtilsTheme";
import boundaryMode from "../utils/boundaryMode";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import turbineControl from "../utils/turbineControl";
import limited_simple_select from "../utils/simple_select";
import limited_direct_select from "../utils/direct_select";
import DialogProject from "../layouts/DialogProject";
import TurfCenterOfMass from '@turf/center-of-mass';
import TurfBBox from '@turf/bbox';
import { Trash, Copy, FloppyDisk, UploadSimple, Polygon, Plus } from "@phosphor-icons/react";
import EditNow from "../components/EditNow";
import globalContext				from "../utils/globalContext";

import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

import key from '../data/mapboxKey'; // eslint-disable-line import/no-webpack-loader-syntax

class Sandbox extends React.Component {

	static contextType = globalContext;
	
	constructor(props) {
		
		super(props);
		this.center = [24.410699837112105, 59.9885433348754];
		this.zoom = 5;
		this.state = {
			user: {},
			loaded:false,
			newProjectDialog:{open:false},
			uploadLayerDialog:{open:false},
			saveProjectDialog:{open:false},
			items:[],
			selectedMap:false,
			map:null,
			saveBtn:false
		};
		this.mapCont = React.createRef();
		this.infoLayerPanel = React.createRef();
		this.map = null;
		
		

		MapboxDraw.modes.simple_select = {...MapboxDraw.modes.simple_select, ...limited_simple_select};
		MapboxDraw.modes.direct_select = {...MapboxDraw.modes.direct_select, ...limited_direct_select};

		this.Draw = new MapboxDraw({
			displayControlsDefault: false,
			controls: {
				polygon: false,
				line_string:false,
				trash: false,
				boundary_mode:true
			},
			userProperties:true,
			styles: drawTheme,
			modes: Object.assign({
				boundary_mode: boundaryMode,
			}, MapboxDraw.modes)
		});
		
		document.title = process.env.REACT_APP_DOC_TITLE;
		
		document.body.className="sandbox";
	}
	getCopy(){
		return JSON.parse(JSON.stringify(this.state.items));
	}
	updateStatus(s, callback){
		var x = {...this.state, ...s};
		this.setState(x, callback);
		this.forceUpdate();
	}
	componentDidMount(){

		

		
		Promise.all([vindrApi.getToken()])
		.then((res) => {
			 
			const dataRequests = [
				authApi.getUser()
			];
			
			return Promise.all(dataRequests);
		}).then((res)=>{
			
			const dataRequests = [
				res[0],
				vindrApi.getUserMaps(res[0].userDetails)
			];
			
			return Promise.all(dataRequests);
		}).then((res)=>{

			this.updateStatus({
				user:res[0],
				items:res[1],
				loaded:true
			});

		}).catch((e)=>{
			this.updateStatus({
				loaded:true
			});

		});
		return;

		
	}
	componentDidUpdate(){
		;
	}
	handleNew(newMap){
		
		var swap = this.getCopy();
		swap.unshift(newMap);
		
		this.updateStatus({items:swap});
	}
	handleUpdate(id, newTitle){
		var swap = this.getCopy();
		var idx = swap.findIndex((i)=>{return i.id == id});

		if(idx != -1){
			swap[idx].title = newTitle;
			this.updateStatus({items:swap});
			vindrApi.updateUserMap(swap[idx]);
		}
	}
	handleCloseMap(){
		this.updateStatus({selectedMap:null, map:null});
		
	}
	handleDropDownClick(e){
		e.preventDefault();
		e.stopPropagation();
	}
	handleDuplicate(item){
		
		
		Promise.all([vindrApi.duplicateUserMap(item)])
		.then((res) => {
			
			if(Array.isArray(res) && res.length && res[0].id)
				this.handleNew(res[0]);
			
			
		}).catch((e)=>{

		});
		
	}
	handleDelete(item){
		
		Promise.all([vindrApi.deleteUserMap(item)])
		.then((res) => {
			var swap = this.getCopy();
			var idx = swap.findIndex((i)=>{return i.id == item.id});
		
			if(idx != -1){
				swap.splice(idx, 1);
				this.updateStatus({items:swap});
			}
			
		}).catch((e)=>{

		});
		
	}
	updateMapSettings(newSettings){
		if(!this.state.selectedMap)
			return;
		
		var newMap = {...this.state.selectedMap, ...newSettings};
		
		var swap = this.getCopy();
		
		var idx = swap.findIndex((i)=>{return i.id == newMap.id;});
		if(idx != -1)
			swap[idx] = newMap;
		this.updateStatus({items:swap, selectedMap:newMap});
		
		vindrApi.updateUserMap(newMap);

	}

	drawProject(e){
		if(this.tc)
			this.tc.addProject(e);
	}
	openNewProject(){
		this.updateStatus({newProjectDialog:{open:true}});
	}
	closeNewProject(){
		this.updateStatus({newProjectDialog:{open:false}});
	}
	openUploadLayer(){
		this.updateStatus({uploadLayerDialog:{open:true}});
	}
	closeUploadLayer(){
		this.updateStatus({uploadLayerDialog:{open:false}});
	}
	openSaveProject(b){
		this.updateStatus({saveProjectDialog:{open:true, boundary:b}});
	}
	closeSaveProject(){
		this.updateStatus({saveProjectDialog:{open:false}});
	}
	
	handleSaveProject(e){
		
		var fc = this.du.draw.getAll();
		
		if(!fc.features || !fc.features.length)
			return;
		
		var b = {...fc.features[0].geometry};
		
		if(fc.features[0].geometry.type != 'MultiPolygon'){
			b.type = 'MultiPolygon';
			b.coordinates = [fc.features[0].geometry.coordinates];
		}
		this.openSaveProject(b);
	}
	handleLayerUpload(layer){
		
		if(this.du && layer.features && layer.features.length){
			
			var feature = {...layer.features[0]};
			
			const center = TurfCenterOfMass(feature.geometry).geometry.coordinates;
			
			
			feature.id = 'boundary';
			
			
			this.du.draw.add(feature);
			this.updateStatus({saveBtn:true})
			this.state.map.fitBounds(TurfBBox(feature));
			this.state.map.flyTo({
				center: center
			});
		}
		
	}
	renderLayers(){
		if(!this.state.map)
			return;
		return (
			<div className="nav-group project-panel show">
				<div id="layers" className="layer-section	mt-3">
					 <InfoLayers ref={this.infoLayerPanel} context={this.context} scenario={{layers:this.state.selectedMap.layers, scenario_id:0}} onChange={(payload)=>{this.updateMapSettings({layers:payload})}} user={this.state.user} map={this.state.map}  />
				</div>
			</div>
		 );
	}
	renderMaps(){
		return this.state.items.map((item, k)=>{
			return (
				<Link className="card-project m-4" key={k}  to={"/pages/sandbox/" + item.id}>
					
						<Card.Body className={"card-img-top "} style={{backgroundImage:"url('"+(item.image ? item.image : '/images/map.png')+"')"}}>
							<Row>
								<Col xl="12" className="text-end">
									
								</Col>
							</Row>
						</Card.Body>
						<Card.Body className="pb-2">
							<Row className="nameBar mb-3">
								<Col xl="10">
									<EditNow id={item.id} value={item.title} editable={true} onUpdate={(title)=>{this.handleUpdate(item.id, title );}} />
								</Col>
								<Col xl="2">
									<Dropdown className="minimal" onClick={(e)=>{this.handleDropDownClick(e);}}>
										<Dropdown.Toggle className="p-0 px-1" variant="default">
											<i className="ri-more-2-fill"></i>
										</Dropdown.Toggle>
										<Dropdown.Menu>
											<Dropdown.Item href="#" onClick={()=>{this.handleDuplicate(item);}}><Copy size={16} /> Duplicate</Dropdown.Item>
											<Dropdown.Item href="#" onClick={(e)=>{document.getElementById('edit-static-'+item.id).dispatchEvent(new MouseEvent("dblclick", {'view': window,'bubbles': true,'cancelable': true}))}}><Copy size={16} /> Rename</Dropdown.Item>
											
											
											 
											 
											<Dropdown.Item href="#" onClick={()=>{this.handleDelete(item);}} className="text-danger"><Trash size={16} /> Delete</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
								</Col>
							</Row>
							<Row>
								<Col xl="7 text-secondary">
									{item.username}
								</Col>
								<Col xl="5 text-end text-secondary">
									{timeAgo(item.updated)}
								</Col>
							</Row>
						</Card.Body>
					
				</Link>
			);
		});

	}
	render() {
		return (
			<>


				<div className="header">

					<div className="menu">
						<i className="ri-menu-2-fill"></i>
					</div>



					<div className="middle">
						<Link to="/" className="header-logo">Site Planner</Link>


					</div>

					<div className="logo">
						<img className="img-fluid d-none d-md-block brand-logo" src="/images/vindr_logo_blue.svg" alt="Vindr"/>
					</div>
					<div className="options">
							{this.state.user.userId && <UserMenu user={this.state.user} onUpdateUser={(u)=>{this.updateStatus({user:u})}} />}
					</div>
				</div>
				<div className="body dashboard2">
					<Sidebar onClick={(e)=>{ e.stopPropagation();}} add={this.renderLayers()} />
					<div className={"main sandbox "}>
						<Row className="mb-4">
							<Col xl>

							</Col>
						</Row>
						<div className="project-list">
						
							<Card className="card-project m-4 empty" onClick={()=>{this.openNewProject();}}>
								<Card.Body className="card-img-top">
									<div><Plus size={72} /></div>
									New map
								</Card.Body>
							</Card>
							
							{this.renderMaps()}
							
						</div>


					</div>


				</div>
				<DialogScreeningMap setup={this.state.newProjectDialog} user={this.state.user} onSave={(n)=>{this.handleNew(n);}} onClose={()=>{this.closeNewProject();}} />
				<Loader loaded={this.state.loaded} message="Loading projects..." />
					
			</>
		);
	}
}


export default Sandbox;